/* src/app/modules/shared/unauthorized/unauthorized.component.scss */
/*# sourceMappingURL=unauthorized.component-TMNTVLEG.css.map */
